import { ProjectAssetMappingBase } from './base/project-asset-mapping-base';

export class ProjectAssetMapping extends ProjectAssetMappingBase { }